import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Parallel } from 'src/app/api/api-campaigns.service.generated';

@Component({
  selector: 'app-parallel-strategy-edit',
  templateUrl: './parallel-strategy-edit.component.html',
  styleUrls: ['./parallel-strategy-edit.component.scss'],
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule
  ]
})
export class ParallelStrategyEditComponent implements OnInit, OnChanges {

  @Input() strategy: Parallel;

  constructor() { }

  ngOnChanges(): void {
    if (!this.strategy) return;
    if (this.strategy && !this.strategy.children)
      this.strategy.children = [];
  }

  ngOnInit() { }

}
